'use client';

import type { TourPackageDetailViewModel } from '@api/index';
import PriceTableModal from '@components/views/tour/components/price-table-modal';
import { useBreakpoint } from '@contexts/breakpoints';
import useBodyScrollLock from '@hooks/useBodyScrollLock';

import { PackageTemplatePriceTableModalShell } from './styled';

interface PackageTemplatePriceTableModalProps {
  isOpen: boolean;
  onClose: () => void;
  packageData?: TourPackageDetailViewModel;
}

const PackageTemplatePriceTableModal = ({
  isOpen,
  onClose,
  packageData,
}: PackageTemplatePriceTableModalProps) => {
  const { xs: isMobile } = useBreakpoint();
  useBodyScrollLock(isOpen && isMobile);

  if (!isOpen) return null;

  return (
    <PackageTemplatePriceTableModalShell>
      <PriceTableModal
        isOpen={isOpen}
        onClose={onClose}
        packageData={packageData}
      />
    </PackageTemplatePriceTableModalShell>
  );
};

export default PackageTemplatePriceTableModal;
